import { render, staticRenderFns } from "./DashboardIb.vue?vue&type=template&id=d5b5fb2c&"
import script from "./DashboardIb.vue?vue&type=script&lang=js&"
export * from "./DashboardIb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports